<template>
  <path
    id="ic_reply_24px"
    d="M10,16v4L3,13l7-7v4.1c5,0,8.5-1.6,11-5.1C20,10,17,15,10,16Z"
    transform="translate(-3 -5)" />
</template>
